import { Download } from '@mui/icons-material';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import { getQueryRut } from 'lib/api/documentPublication';
import CustomButton from 'lib/designSystem/Button';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

type DialogProps = {
  open: boolean;
  onClose: () => void;
  identifier: string;
};

const SuccessDialog: React.FC<DialogProps> = ({
  open,
  onClose,
  identifier,
}: DialogProps) => {
  const dispatch = useDispatch();
  const [certificateLink, setCertificateLink] = useState('');

  const getDocumentInfo = async () => {
    const response = await getQueryRut(dispatch, identifier);
    if (!response) return;
    setCertificateLink(response.certificateLink);
  };

  const handleDownloadCertificate = () => {
    if (identifier) {
      window.open(certificateLink, '_blank');
    }
  };

  useEffect(() => {
    if (!identifier) return;
    try {
      void getDocumentInfo();
    } catch (error) {
      console.error(error);
    }
  }, [identifier]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="success-dialog-title"
      aria-describedby="success-dialog-description"
    >
      <DialogTitle id="success-dialog-title">Documento Publicado</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          El documento ha sido publicado exitosamente.
        </Typography>
        <Grid container justifyContent="flex-end" spacing={1} marginTop="10px">
          <Grid item>
            <CustomButton
              color="primary"
              startIcon={<Download />}
              onClick={handleDownloadCertificate}
            >
              Descargar Certificado
            </CustomButton>
          </Grid>
          <Grid item>
            <CustomButton onClick={onClose}>Aceptar</CustomButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog;
